import { addToCartBtnAnimation } from "./micro-interactions";
import { addToCart, removeFromCart } from "./update";


/**
 * Helper function to add a event listener to all "add product" buttons
 */
export function addProductListeners() {
    const addProductButtons = document.querySelectorAll(".cart-item-add-btn");
    addProductButtons?.forEach((button) => {
        // Get product id from the element's dataset
        const productId = button.dataset.productId;
        // Remove old event listener if exists
        button.removeEventListener("click", () => {
            addToCart(productId);
            addToCartBtnAnimation(button);
        });
        // Add event listeners "click" to all button to add products
        button.addEventListener("click", () => {
            addToCart(productId);
            addToCartBtnAnimation(button);
        });
    });
}


/**
 * Helper function to add a event listener to all "remove product" buttons
 */
export function removeProductListeners() {
    const removeProductButtons = document.querySelectorAll(".cart-item__remove-btn");
    removeProductButtons?.forEach((button) => {
        // Get product id from the element's dataset
        const productId = button.dataset.productId;
        // Remove old event listener if exists
        button.removeEventListener("click", () => removeFromCart(productId));
        // Add event listeners "click" to all button to add products
        button.addEventListener("click", () => removeFromCart(productId));
    });
}